export default {"src":"/_next/static/media/pacte-bonne-conduite.c4de1e0c.svg","height":33,"width":32,"blurWidth":0,"blurHeight":0};